import React from "react";
import AutoVisionTransactionContainer from "../../containers/Transaction/AutoVisionTransaction";

function AutoVisionTransaction(props) {
  return <AutoVisionTransactionContainer {...props} />;
}

export default AutoVisionTransaction;
